<template>
  <div>
    <!-- <div v-if="isFormUnavailable" class="unavailable-container">
      <p class="unavailable-message">The form is currently unavailable.</p>
    </div>

    <div v-else> -->
    <div v-if="joiningDetails?.joiningDetails && joiningDetails?.isjoining">
      <!-- <preview-joining-data :data="joiningData" /> -->
      <preview-joining-form
        :formMasterId="joiningDetails.joiningDetails.formMasterId"
        :formVersionId="joiningDetails.joiningDetails.formVersionId"
        :isEditable="isFormEditable"
      />
    </div>
    <div v-if="joiningDetails?.isjoining && !joiningDetails?.joiningDetails">
      <JoiningFormRender />
    </div>
  </div>
  <!-- </div> -->
</template>

<script>
// import previewJoiningData from "./preview-joining
import previewJoiningForm from "./preview-joining-form.vue";
import JoiningFormRender from "./joining-form-render.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    previewJoiningForm,
    JoiningFormRender,
  },
  data() {
    return {
      formMasterId: null,
      formVersionId: null,
    };
  },
  computed: {
    ...mapGetters({
      joiningDetails: "$_applicant_master/getJoiningDetails",
      allForms: "$_form_template/getForms",
    }),
    isFormEditable() {
      if (this.joiningDetails?.joiningDetails) {
        // Get the formMasterId from joiningDetails
        const formMasterId = this.joiningDetails.joiningDetails.formMasterId;

        // Find the form from allForms using only formMasterId
        const selectedForm = this.allForms.find(
          (form) => form.id === formMasterId
        );
        // If no form is found or visibility is private, return false (non-editable)
        if (!selectedForm || selectedForm.visibility === "private") {
          return false;
        }
      }
      return true; // If no specific condition matched, return true (editable)
    },
  },
  watch: {
    joiningDetails(newData) {
      if (newData && !newData.isjoining) {
        this.$router.push({ name: "401" });
      }
    },
  },
  created() {
    this.$store.dispatch("$_applicant_master/getJoiningDetails");
    this.$store.dispatch("$_form_template/getAllFormMasters");
  },
};
</script>
